import React from 'react';
import project12 from './../../image/project12.png'

const MotorParts = () => {
    return (
        <div>
            <div className=' my-24 '>

                <div class=" container mx-auto grid grid-cols-1  gap-4">
                    <div class="card w-100 bg-base-100 shadow-xl">
                        <figure><img src={project12} alt="Shoes" /></figure>
                        <div class="card-body">
                            <h2 class="card-title text-3xl font-bold">
                                Motor Parts Manufactuerer
                                <div class="badge badge-secondary">Full-Stack</div>
                            </h2>
                            <h2 className='text-2xl font-bold'>Features</h2>
                            <p>Interactive User Interface
                                Dashboard for Admin and User
                                User can place an order by signin to the website
                                From Dashboard User can see their previous all placed order
                                From Dashboard Admin can see users all order and can delete them.
                                User can review the site from Dashboard
                                An Admin can add another admin</p>
                            <h2 className='text-2xl font-bold'>Used Technology</h2>
                            <ol>
                                <li>React</li>
                                <li>React Router Dom</li>
                                <li>Firebase Authentication</li>
                                <li>Environmente Variable</li>
                                <li>Tailwind CSS with DaisyUI</li>
                                <li>React Hook Form</li>
                                <li>React Query</li>
                                <li>Heroku for server Deployment</li>
                            </ol>
                            <div class="card-actions justify-end">
                                <a className='btn btn-primary' href="motor-parts-manufacturer.web.app/" target='_blank'>Live Site</a>
                                <a className='btn btn-primary' href="https://github.com/sajolbhadra/motor-parts-manufacturer-client-side" target='_blank'>Client Git Repo</a>
                                <a className='btn btn-primary' href="https://github.com/sajolbhadra/motor-parts-manufacturer-server-side" target='_blank'>Server Git</a>
                            </div>
                        </div>
                    </div>
                </div>

            </div>


        </div>
    );
};

export default MotorParts;